import { connect } from 'react-redux';
import { saveProfile } from '../../actions/userActions';
import ChangePasswordModal from './ChangePasswordModal';

export default connect(null, { saveProfile })(ChangePasswordModal);
